import { Conventions } from "../../../listsSettings/conventions";

export const allItems: string = `/${Conventions.InternalName}/_lists/${Conventions.Lists.Attachments.InternalName}/_pages/all_items`;
export const newForm: string = `/${Conventions.InternalName}/_lists/${Conventions.Lists.Attachments.InternalName}/_pages/new`;
export const dispForm: string = `/${Conventions.InternalName}/_lists/${Conventions.Lists.Attachments.InternalName}/_pages/disp`;
export const editForm: string = `/${Conventions.InternalName}/_lists/${Conventions.Lists.Attachments.InternalName}/_pages/edit`;
